import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from './services/event.service';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, style, animate, transition, state, keyframes } from '@angular/animations';
import { ActivatedRoute, Router, ActivationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  animations: [
    trigger('visibility', [
      state('hasimage', style({ opacity: '1' })),
      state('noimage', style({ opacity: '0.5' })),
      transition('hasimage <=> noimage', animate(400))
    ])
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  public loading = true;
  public state: 'hasimage' | 'noimage' = 'noimage';
  public eventTheme: string;
  public eventImage: string;
  public eventName: string;
  public eventStartDate: Date;
  public eventEndDate: Date;
  public eventLogoType: string;
  public dateFormat: string;

  constructor(private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private domSanitizer: DomSanitizer) {

    this.router.events.subscribe((val) => {
      if (val instanceof ActivationEnd) {
        const activationEnd: ActivationEnd = val;
        if (activationEnd.snapshot.params['eventKey'] === undefined) {
          this.loading = false;
        }
      }
    });

    translate.setDefaultLang('en-US');
  }

  ngOnInit() {
    this.eventService.Event.subscribe((next) => {
      if (next) {
        this.loading = false;
        if (next.portalImageData !== null) {
          this.state = 'hasimage';
        }
        this.eventImage = next.portalImageData;
        this.eventTheme = next.eventTheme ? `#${next.eventTheme}` : '#01689B'; // default @color-primary-blue
        this.eventName = next.name;
        this.eventStartDate = next.eventStartDate;
        this.eventEndDate = next.eventEndDate;

        this.eventLogoType = next.portalImageTheme;
        this.translate.use(next.language);
      }
    },
      (error) => {
        this.loading = false;
        this.router.navigate(['/error-page/unexpected-api-error']);
      });

    this.translate.onLangChange.subscribe((next) => {
      this.dateFormat = next.lang;
    });
  }
}
